import { createSlice } from '@reduxjs/toolkit'
import { service } from '../shared/_services/api_service'
import { setLoading } from './loader';
import { errorHandler, successHandler } from '../shared/_helper/responseHelper';

const STATUS = Object.freeze({
  IDLE: 'idle',
  ERROR: 'error',
  LOADING: 'loading'
});

const initialState = {
  loadingStatus: STATUS.IDLE,
  settingsData: [],
}

export const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setSettingsData(state, { payload }) {
      state.settingsData = payload
    },
  }
})

export const { setSettingsData } = settingsSlice.actions;

export default settingsSlice.reducer;

export function getSettings() {
  return async function getSettingsThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.getSettingsData().then(
        (response) => {
          dispatch(setSettingsData(response.data))
          dispatch(setLoading(false))
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function updateSettings(data) {
  return async function updateSettingsThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.updateSettingsData(data).then(
        (response) => {
          dispatch(setSettingsData(response.data))
          dispatch(setLoading(false))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
